// extracted by mini-css-extract-plugin
export default {"code":"bc_dv"};